/**
 * NotFoundRedirect — catch-all target for App.jsx's `path="*"`.
 *
 * The embed shell (`/embed/*`) has no ProtectedRoute redirecting to /login
 * (EMB-13 AC8), but an unmatched path under it still fell through to this
 * SIBLING route — outside `EmbedEntry`/`EmbedProvider`, so `useEmbed()` here
 * would only ever see the default `{ isEmbed: false }` context value, not
 * the real one. A stale bookmark, a typo, or any second-level route not yet
 * mirrored under /embed (see PLAN_embed-account-scope.md) landed the user on
 * `/internal/dashboard` — the non-white-label layout, outside the partner's
 * iframe. `location.pathname` is checked directly instead, the same signal
 * InternalLayout.jsx already uses for the same reason.
 */
import { Navigate, useLocation } from "react-router-dom";
import { embedPath } from "@/utils/accountRoutes";

export default function NotFoundRedirect() {
  const location = useLocation();
  const target = location.pathname.startsWith("/embed") ? embedPath("") : "/internal/dashboard";
  return <Navigate to={target} replace />;
}
